import { render, staticRenderFns } from "./TruncatedSpan.vue?vue&type=template&id=4f35b777&functional=true&"
import script from "./TruncatedSpan.vue?vue&type=script&lang=js&"
export * from "./TruncatedSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports